export default __webpack_public_path__ + "static/media/hunter.52707106.png";